import React from 'react'
import ColorsContainer from './ColorsContainer'

const Colors = props => <ColorsContainer {...props} data-test="component-tradeIn-colors" />

export default Colors
